module.exports = "/* You can add global styles to this file, and also import other style files */\nh1 {\n    font-size: 300%;\n}"